var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.119,
    height: 17,
    viewBox: "0 0 15.119 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar_today_FILL0_wght300_GRAD0_opsz24",
    d: "M141.609-847.614a1.552,1.552,0,0,1-1.141-.467,1.552,1.552,0,0,1-.467-1.141v-11.9a1.552,1.552,0,0,1,.467-1.141,1.552,1.552,0,0,1,1.141-.467h1.231v-1.2a.663.663,0,0,1,.2-.488.663.663,0,0,1,.488-.2.663.663,0,0,1,.488.2.663.663,0,0,1,.2.488v1.2h6.738v-1.214a.646.646,0,0,1,.192-.475.646.646,0,0,1,.475-.192.646.646,0,0,1,.475.192.646.646,0,0,1,.192.475v1.214h1.231a1.552,1.552,0,0,1,1.141.467,1.552,1.552,0,0,1,.467,1.141v11.9a1.552,1.552,0,0,1-.467,1.141,1.552,1.552,0,0,1-1.141.467Zm0-1.334h11.9a.262.262,0,0,0,.188-.086.261.261,0,0,0,.086-.188v-8.346H141.335v8.346a.261.261,0,0,0,.085.188A.262.262,0,0,0,141.609-848.948Zm-.274-9.954h12.451v-2.223a.262.262,0,0,0-.086-.188.262.262,0,0,0-.188-.086h-11.9a.262.262,0,0,0-.188.086.262.262,0,0,0-.085.188Zm0,0v0Z",
    transform: "translate(-140.001 864.614)",
    fill: "#072635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSchedule);
export default __webpack_public_path__ + "static/media/ic_schedule.a507bf19d18aaf3bc29cf5e18b348a13.svg";
export { ForwardRef as ReactComponent };